import { $switchCaseStrict } from 'dolla-switch';
import { SocialNetwork } from '@prezi/viewer-common';
import { actions } from '../../actions/actions';
import { unifiedPrivacyActions } from '../../actions/unifiedPrivacyActions';
import { viewLinkActions } from '../../actions/viewLinkActions';
import { documentTypeSelector, productTypeSelector, setPrivacyParamsSelector } from './selectors';
import { boolToOnOff, permissionValueToCollaboratorRole, schemaVersionNameToDocumentType } from '../../../utils/mappings';
import { getGlassboxLogger } from '../../../glassboxLogger';
const getSetPrivacyParams = (state, payload) => Object.assign(setPrivacyParamsSelector(state), payload);
export const glassboxMiddleware = store => next => action => {
  const state = store.getState();
  switch (action.type) {
    case unifiedPrivacyActions.setPublished.actionType:
      {
        getGlassboxLogger().logSetPrivacy(getSetPrivacyParams(state, {
          privacy_public: action.payload.isPublished,
          privacy_level: action.payload.isPublished ? 'PUBLIC' : 'PRIVATE'
        }));
        break;
      }
    case unifiedPrivacyActions.setReusable.actionType:
      {
        getGlassboxLogger().logSetPrivacy(getSetPrivacyParams(state, {
          privacy_reusable: action.payload.isReusable
        }));
        break;
      }
    case unifiedPrivacyActions.setUnifiedPrivacy.actionType:
      {
        getGlassboxLogger().logSetPrivacy(getSetPrivacyParams(state, {
          privacy_link_access: $switchCaseStrict(action.payload.unifiedPrivacy, {
            open: () => 'ACCESSIBLE_WITH_LINK',
            closed: () => 'COLLABORATOR_ONLY'
          })
        }));
        break;
      }
    case actions.updateCollaborator.actionType:
      {
        getGlassboxLogger().logUpdateCollaborator({
          prezi_oid: state.documentOid,
          collaborator_role: permissionValueToCollaboratorRole(action.payload.permission),
          document_type: documentTypeSelector(state)
        });
        break;
      }
    case actions.removeCollaborator.actionType:
      {
        getGlassboxLogger().logUpdateCollaborator({
          prezi_oid: state.documentOid,
          collaborator_role: 'NONE',
          document_type: documentTypeSelector(state)
        });
        break;
      }
    case actions.setPage.actionType:
      {
        switch (action.payload) {
          case 'viewLinks':
            getGlassboxLogger().logOpenAllViewLinks({
              prezi_oid: state.documentOid
            });
            break;
          case 'embed':
            break;
          default:
            break;
        }
        break;
      }
    case actions.addFolderCollaborator.actionType:
      {
        getGlassboxLogger().logAddFolderCollaborator({
          folder_uid: action.payload.folderUuid
        });
        break;
      }
    case actions.removeFolderCollaborator.actionType:
      {
        getGlassboxLogger().logRemoveFolderCollaborator({
          folder_uid: action.payload.folderUuid,
          target_user_id: action.payload.collaboratorId
        });
        break;
      }
    case actions.addFolderCollaboratorError.actionType:
      {
        getGlassboxLogger().logAddFolderCollaboratorFailed({
          add_folder_collaborator_error_message: 'ERROR_ADDING_MEMBER',
          folder_uid: action.payload.folderUuid
        });
        break;
      }
    case viewLinkActions.createViewlink.actionType:
      {
        getGlassboxLogger().logCreatedViewLink({
          prezi_oid: state.documentOid,
          analytics_tracking_state: boolToOnOff(action.payload.visibleOnAnalytics),
          viewer_identification_state: boolToOnOff(action.payload.viewerIdentification)
        });
        break;
      }
    case viewLinkActions.updateViewlink.actionType:
      {
        const {
          oldViewLink,
          viewLink
        } = action.payload;
        if (oldViewLink.name !== viewLink.name) {
          getGlassboxLogger().logChangedViewLinkName({
            prezi_oid: state.documentOid,
            view_link_oid: action.payload.linkId
          });
        }
        if (oldViewLink.visible_on_analytics !== viewLink.visible_on_analytics) {
          getGlassboxLogger().logChangedAnalyticsTracking({
            prezi_oid: state.documentOid,
            view_link_oid: action.payload.linkId,
            analytics_tracking_state: boolToOnOff(viewLink.visible_on_analytics)
          });
        }
        if (oldViewLink.viewer_identification !== viewLink.viewer_identification) {
          getGlassboxLogger().logChangedViewerIdentification({
            prezi_oid: state.documentOid,
            view_link_oid: action.payload.linkId,
            viewer_identification_state: boolToOnOff(viewLink.viewer_identification)
          });
        }
        break;
      }
    case viewLinkActions.removeViewlink.actionType:
      {
        getGlassboxLogger().logDeactivatedViewLink({
          prezi_oid: state.documentOid,
          delete_analytics_tracking_data: action.payload.deleteData,
          view_link_oid: action.payload.linkId
        });
        break;
      }
    case viewLinkActions.copyToClipboard.actionType:
      {
        var _state$unifiedPrivacy;
        getGlassboxLogger().logCopyViewLink({
          prezi_oid: state.documentOid,
          view_link_oid: (_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.view_token,
          document_type: documentTypeSelector(state)
        });
        break;
      }
    case viewLinkActions.logSocialShare.actionType:
      {
        var _state$document$value;
        getGlassboxLogger().logOpenSocialShare({
          prezi_oid: state.documentOid,
          social_media_platform: action.payload.network === SocialNetwork.GOOGLE_CLASSROOM ? 'GOOGLE' : action.payload.network,
          document_type: schemaVersionNameToDocumentType((_state$document$value = state.document.value) === null || _state$document$value === void 0 ? void 0 : _state$document$value.schema_version_name)
        });
        break;
      }
    case actions.logOpenCopyEmbedCode.actionType:
      getGlassboxLogger().logCopyEmbedCodeToClipboard({
        prezi_oid: state.documentOid,
        product_type: productTypeSelector(state)
      });
      break;
    default:
      {
        break;
      }
  }
  return next(action);
};